module.exports = __webpack_public_path__ + "img/82062b9f49d8433cbcf5994beed13703_mergeImage.b3995fd9.png";